const addAgreementsActions = {
  ADD_AGREEMENTS_INIT: 'ADD_AGREEMENTS_INIT',
  ADD_AGREEMENTS_SET: 'ADD_AGREEMENTS_SET'
};
export default addAgreementsActions;
